import React, { Component } from "react";
import { Row, Col, Button, Alert } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import Formsy from "formsy-react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TextInput } from "../Shared/Forms";
import { Spinner } from "../Shared";

import { cardTypeActions } from "./actions/cardstypes.actions";
import { routeConstants } from "../../_constants";

export class CardTypeForm extends Component {
  state = {
    canSubmit: false
  };

  componentDidMount() {
    this.getCardType();
  }

  componentWillUnmount() {
    this.props.resetCardType();
  }

  getCardType = () => {
    const { match } = this.props;
    if (match.params && match.params.id) {
      this.props.getCardType(match.params.id);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.submitted) {
      this.refs.cardTypeForm.reset();
    }
  }

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  handleSubmit = data => {
    const { match } = this.props;
    const hasParams = match.params && match.params.id;
    if (hasParams) {
      data = {
        id: match.params.id,
        ...data
      };
    }
    this.props.addCardType(data);
  };

  render() {
    const { canSubmit } = this.state;
    const { submitting, match, viewResponse, viewError, fetched } = this.props;
    const cardType = viewResponse && fetched ? viewResponse.modelList[0] : null;
    const hasParams = match.params && match.params.id;
    return (
      <div>
        <Row>
          <Col sm="6">
            <Link
              className="btn btn-outline btn-primary"
              to={routeConstants.CARDTYPES.path}
            >
              <MdArrowBack /> Back to list
            </Link>
          </Col>
          <Col sm="6">
            <div className="text-right">
              <h5 className="item-count">
                {hasParams ? "Edit" : "Add"} Card Type
                <small>
                  {cardType && hasParams ? `: ${cardType.code}` : null}
                </small>
              </h5>
            </div>
          </Col>
        </Row>
        <hr />
        <Row>
          <Col sm="4">
            {viewError ? (
              <Alert color="danger">
                <strong>Error:</strong> {viewError.message}
              </Alert>
            ) : (
              <Formsy
                ref="cardTypeForm"
                onValidSubmit={this.handleSubmit}
                onValid={this.enableButton}
                onInvalid={this.disableButton}
                noValidate
              >
                <TextInput
                  name="code"
                  value={cardType && hasParams ? cardType.code : null}
                  required
                  disabled={submitting || hasParams}
                  title="Card type code"
                />
                <TextInput
                  name="description"
                  value={cardType && hasParams ? cardType.description : null}
                  required
                  disabled={submitting}
                  title="Card type description"
                />
                <Button
                  type="submit"
                  color="primary"
                  disabled={!canSubmit || submitting}
                >
                  {submitting ? <Spinner /> : "Submit"}
                </Button>
              </Formsy>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { submitting, submitted, request, response, error } = state.addCardType;

  const {
    fetching,
    fetched,
    request: viewRequest,
    response: viewResponse,
    error: viewError
  } = state.viewCardType;

  return {
    submitting,
    submitted,
    request,
    response,
    error,
    fetching,
    fetched,
    viewRequest,
    viewResponse,
    viewError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addCardType: bindActionCreators(cardTypeActions.addCardType, dispatch),
    resetCardType: bindActionCreators(cardTypeActions.resetCardType, dispatch),
    getCardType: bindActionCreators(cardTypeActions.getCardType, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardTypeForm);
